import React, { useState } from "react";
import {
  Box,
  Button,
  Grid,
  TextField,
  Typography,
  CircularProgress,
  Chip,
  Stack,
} from "@mui/material";
import { TabContext } from "@mui/lab";
import { useSelector } from "react-redux";
import { back } from "../iconsImports";
import { postJsonData } from "../network/ApiController";
import ApiEndpoints from "../network/ApiEndPoints";
import { apiErrorToast, okSuccessToast } from "../utils/ToastUtil";

const NewCreditCard = ({ resetView, name }) => {
  const { tripType } = useSelector((state) => state?.flight);

  const [formData, setFormData] = useState({
    service: name || "",
    description: "",
  });
  const [loading, setLoading] = useState(false);

  const handleBack = () => resetView(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handlePresetClick = (text) => {
    setFormData((prev) => ({ ...prev, description: text }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!formData.service || !formData.description) {
      apiErrorToast("Please fill all required fields");
      return;
    }

    postJsonData(
      ApiEndpoints.CREATE_LEAD,
      formData,
      setLoading,
      (res) => {
        okSuccessToast("Lead created successfully!");
        setFormData({ service: name || "", description: "" });
      },
      (err) => apiErrorToast(err)
    );
  };

  return (
    <TabContext value={tripType || "oneway"}>
      {/* Back Button */}
      <Grid
        item
        xs={12}
        sm="auto"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          mr: 2,
          mt: 1,
        }}
      >
        <Button
          size="small"
          id="verify-btn"
          className="button-props"
          onClick={handleBack}
        >
          <span style={{ marginRight: "5px" }}>Home</span>
          <img
            src={back}
            alt="back"
            style={{ width: "18px", height: "20px" }}
          />
        </Button>
      </Grid>

      {/* Form Section */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "80vh",
          p: 3,
          background: "#fafafa",
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: "500px",
            bgcolor: "white",
            p: 4,
            boxShadow: 3,
            borderRadius: 2,
          }}
          component="form"
          onSubmit={handleSubmit}
        >
          <Typography
            variant="h5"
            sx={{
              mb: 2,
              fontWeight: "bold",
              textAlign: "center",
              color: "#ff5722",
            }}
          >
            Create New Lead
          </Typography>

          {/* Service (Disabled Field) */}
          <TextField
            label="Service"
            name="service"
            value={formData.service}
            fullWidth
            margin="normal"
            disabled
          />

          {/* Suggested Descriptions */}
          <Typography sx={{ mt: 2, mb: 1, fontWeight: 500 }}>
            Quick Suggestions:
          </Typography>
          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
            {[
              "Yes, I am interested",
              "Please share more details",
              "I want to know the benefits",
              "Call me to discuss this service",
            ].map((text, index) => (
              <Chip
                key={index}
                label={text}
                onClick={() => handlePresetClick(text)}
                clickable
                sx={{
                  cursor: "pointer",
                  bgcolor:
                    formData.description === text ? "#ff5722" : "#f0f0f0",
                  color: formData.description === text ? "white" : "inherit",
                  fontWeight: formData.description === text ? "bold" : "normal",
                }}
              />
            ))}
          </Stack>

          {/* Description Field */}
          <TextField
            label="Description"
            name="description"
            value={formData.description}
            onChange={handleChange}
            fullWidth
            margin="normal"
            required
            multiline
            rows={3}
            sx={{ mt: 2 }}
          />

          <Box sx={{ mt: 3, textAlign: "center" }}>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              disabled={loading}
              sx={{ minWidth: "150px", textTransform: "none" }}
            >
              {loading ? (
                <CircularProgress size={24} sx={{ color: "white" }} />
              ) : (
                "Submit"
              )}
            </Button>
          </Box>
        </Box>
      </Box>
    </TabContext>
  );
};

export default NewCreditCard;
